/**
 * MultiLineBar (2026-07-27)
 * =========================
 * Server-side multi-line control surface. The agent keeps ONE browser SIP leg;
 * Asterisk swaps the agent's bridge between the caller and the 3rd party. This
 * bar shows the two lines, lets the agent click to switch, hang up a line, or
 * Merge both into a conference.
 *
 * Props:
 *   active      : 'caller' | 'third'   which line the agent is talking to
 *   callerLabel : string               display for the caller
 *   thirdLabel  : string               display for the 3rd party
 *   onSwap(to)  : switch to 'caller'|'third'
 *   onHangup(which) : hang up 'caller'|'third'
 *   onMerge()   : merge both into a conference
 */
import React from 'react';

function Line({ who, label, active, onClick, onHangup }) {
  return (
    <div className={`cx-mlline ${active ? 'cx-mlline--active' : ''}`}>
      <button
        type="button"
        className="cx-mlline__pick"
        onClick={onClick}
        title={active ? `Talking to ${label}` : `Switch to ${label}`}
      >
        <span className="cx-mlline__who">{who === 'caller' ? '📞' : '👤'} {label}</span>
        <span className="cx-mlline__state">{active ? '🎙️ talking' : '⏸ on hold'}</span>
      </button>
      <button
        type="button"
        className="cx-mlline__txtbtn cx-mlline__txtbtn--danger"
        onClick={onHangup}
        title={`Hang up ${label}`}
      >
        END
      </button>
    </div>
  );
}

export default function MultiLineBar({
  active,
  callerLabel = 'Caller',
  thirdLabel = '3rd party',
  onSwap,
  onHangup,
  onMerge,
}) {
  return (
    <div className="cx-mlbar">
      <div className="cx-mlbar__title">Two lines — click a line to talk, or Merge to conference</div>
      <div className="cx-mllines">
        <Line
          who="caller"
          label={callerLabel}
          active={active === 'caller'}
          onClick={() => active !== 'caller' && onSwap && onSwap('caller')}
          onHangup={() => onHangup && onHangup('caller')}
        />
        <Line
          who="third"
          label={thirdLabel}
          active={active === 'third'}
          onClick={() => active !== 'third' && onSwap && onSwap('third')}
          onHangup={() => onHangup && onHangup('third')}
        />
      </div>
      <button type="button" className="cx-mlbar__merge" onClick={() => onMerge && onMerge()}>
        Merge into conference
      </button>
    </div>
  );
}
